import { render } from "./Diagram.vue?vue&type=template&id=5bd358be&scoped=true&bindings={}"
import script from "./Diagram.vue?vue&type=script&lang=ts"
export * from "./Diagram.vue?vue&type=script&lang=ts"

import "./Diagram.vue?vue&type=style&index=0&id=5bd358be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bd358be"

export default script